import React, { useContext } from 'react';

import styled from '@emotion/styled';

import { ModalContext, ModalProvider } from '../../../context/ModalContext';
import SetPackageStatusModal from '../../../sections/dashboard/home/SetPackageStatusModal';
import { HoverDropDown } from '../../DropDown/DropDown';
import HorizontalDot from '../../Icons/HorizontalDot';
import { Modal } from '../../Modal/Modal';

const IconContainer = () => {
  const modalContext = useContext(ModalContext);

  const setItemStatusHandler = (e: any) => {
    modalContext?.displayModal(true);
  };
  return (
    <IconContainerWrapper
      onClick={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        e.stopPropagation();
      }}
    >
      <HoverDropDown className="options" label={<HorizontalDot />}>
        <DropDownContent
          onClick={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
            setItemStatusHandler(e);
            e.stopPropagation();
          }}
        >
          Update Status
        </DropDownContent>
      </HoverDropDown>
    </IconContainerWrapper>
  );
};

interface IPendingInBoundStatusComponent {
  children: string;
  noMenu?: boolean;
  tModalData: any;
}

const PendingInBoundStatusComponent: React.FC<
  IPendingInBoundStatusComponent
> = ({ children, noMenu, tModalData }) => {
  //   console.log('tModalData>>>>>', tModalData);
  const RenderedStatus = () => {
    if (children === 'PENDING') {
      return 'Pending';
    } else if (children === 'CLEARED') {
      return 'Cleared';
    } else if (children === 'INCUSTOMS') {
      return 'In Customs';
    } else if (children === 'IN_CUSTOMS') {
      return 'In Customs';
    } else if (children === 'RECEIVED') {
      return 'Received';
    } else if (children === 'PICKEDUP') {
      return 'Picked-up';
    } else if (children === 'DELIVERED') {
      return 'Delivered';
    } else if (children === 'AT_WAREHOUSE') {
      return 'At Warehouse';
    }
  };

  return (
    <ModalProvider>
      <Container>
        <StatusDiv className={children}>{RenderedStatus()}</StatusDiv>
        {!noMenu && <IconContainer />}
      </Container>
      <Modal>
        <SetPackageStatusModal tdata={tModalData} />
      </Modal>
    </ModalProvider>
  );
};

export default PendingInBoundStatusComponent;

const DropDownContent = styled.div`
  display: flex;
  padding: 1rem;
  width: 150px;

  &:hover {
    background-color: ${({ theme }) => theme.palette.brandBackdrop};
  }
`;

const Container = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: space-between;
`;

const IconContainerWrapper = styled.div`
  display: flex;
  padding: 0.25rem 0.5rem;
`;

const StatusDiv = styled.div`
  text-align: center;
  border-radius: 0.5rem;
  padding: 0.25rem 0.5rem;
  width: fit-content;
  text-transform: capitalize;
  font-size: 0.875rem;
  align-self: flex-start;

  &.CLEARED {
    color: #22b231;
    background-color: #ebf7ee;
  }
  &.PENDING {
    color: #f46f3b;
    background-color: #fef8f5;
  }
  &.IN_CUSTOMS {
    color: #139ab7;
    background-color: #f1fbfe;
  }
  &.INCUSTOMS {
    color: #139ab7;
    background-color: #f1fbfe;
  }
  &.RECEIVED {
    color: #22b231;
    background-color: #fef8f5;
  }
  &.PICKEDUP {
    color: #0f33f0;
    background-color: #ebf7ee;
  }
  &.DELIVERED {
    color: #22b231;
    background-color: #fef8f5;
  }
  &.AT_WAREHOUSE {
    color: #22b231;
    background-color: #fef8f5;
  }
`;
